module.exports = "/_next/static/images/RealTimeAudience-a5727a50158370a5b037407fe3725780.webp";